import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildArtifactDocument } from './htmlShell';
import css from './HtmlArtifactFrame.css';

const SANDBOX = 'allow-scripts';

const HtmlArtifactFrame = ({ html, title, placeholder = null }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <>
            {!isLoaded && placeholder}
            <iframe
                className={classNames(css.frame, { [css.pending]: !isLoaded })}
                title={title}
                sandbox={SANDBOX}
                referrerPolicy="no-referrer"
                srcDoc={buildArtifactDocument(html)}
                onLoad={() => setIsLoaded(true)}
            />
        </>
    );
};

HtmlArtifactFrame.propTypes = {
    html: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.node,
};

export default HtmlArtifactFrame;
